import { gql } from "@/gql";

// Holiday queries
export const GET_HOLIDAYS = gql(`
  query GetHolidays($salonId: ID!, $scope: String, $isActive: Boolean, $timeFilter: String) {
    getHolidays(salonId: $salonId, scope: $scope, isActive: $isActive, timeFilter: $timeFilter) {
      id
      franchiseId
      name
      message
      startDateTime
      endDateTime
      blockOnlineBooking
      scope
      isActive
      createdAt
      updatedAt
      holidaySalons {
        id
        salonId
      }
    }
  }
`);

export const GET_HOLIDAY = gql(`
  query GetHoliday($holidayId: ID!) {
    getHoliday(holidayId: $holidayId) {
      id
      franchiseId
      name
      message
      startDateTime
      endDateTime
      blockOnlineBooking
      scope
      isActive
      createdAt
      updatedAt
      holidaySalons {
        id
        salonId
      }
    }
  }
`);

// Holiday mutations
export const CREATE_HOLIDAY = gql(`
  mutation CreateHoliday($input: CreateHolidayInput!) {
    createHoliday(input: $input) {
      id
      franchiseId
      name
      message
      startDateTime
      endDateTime
      blockOnlineBooking
      scope
      isActive
      createdAt
      updatedAt
      holidaySalons {
        id
        salonId
      }
    }
  }
`);

export const UPDATE_HOLIDAY = gql(`
  mutation UpdateHoliday($input: UpdateHolidayInput!) {
    updateHoliday(input: $input) {
      id
      franchiseId
      name
      message
      startDateTime
      endDateTime
      blockOnlineBooking
      scope
      isActive
      createdAt
      updatedAt
      holidaySalons {
        id
        salonId
      }
    }
  }
`);

export const DELETE_HOLIDAY = gql(`
  mutation DeleteHoliday($holidayId: ID!) {
    deleteHoliday(holidayId: $holidayId)
  }
`);
